import { motion } from "framer-motion";
import React from "react";
import CampusesSection from "./Home/CampusesSection";
import EventsSection from "./Home/EventsSection";
import MinistriesSection from "./Home/MinistriesSection";
import SermonSection from "./Home/SermonSection";
import ServeSection from "./Home/ServeSection";
import SocialsSection from "./Home/SocialsSection";
import WelcomeSection from "./Home/WelcomeSection";

const ACCESS_TOKEN = "EAAW2xrVlunoBOxH3OXOLqBTO5srLvspu61oWnSTchgIhprATMPp71lziGyEmMiLM6seDEQZBsaPAc6Rwmx46mwUkhwlwzUER8SqnVEJzCokkxUZCH9p1L2cEp1EUZBCR8ssQf2rbnbUWX6JyzMMcfZAv0o1h090ZCLZB2gTtiNo3rJfs5SnFnoEvRbDyCrTbxhZBX9wrCZAZBP4md3EjjHNmErrdmyVIbGO1ZAH4cvZCzWZB";
const PAGE_ID = "203411489522199";

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      when: "beforeChildren"
    }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 10
    }
  }
};

const Home = () => {
  return (
    <motion.main
      className="font-sans mx-auto px-4 pt-20 max-w-7xl"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.div variants={itemVariants}>
        <SermonSection />
      </motion.div>

      <motion.div 
        className="flex flex-col gap-4 sm:flex-row px-5"
        variants={containerVariants}
      >
        <WelcomeSection />

        <motion.div 
          className="w-full sm:w-1/2"
          variants={containerVariants}
        >
          <motion.div variants={itemVariants}>
            <ServeSection />
          </motion.div>
          <motion.div variants={itemVariants}>
            <MinistriesSection />
          </motion.div>
          <motion.div variants={itemVariants}>
            <EventsSection />
          </motion.div>
          <motion.div variants={itemVariants}>
            <CampusesSection />
          </motion.div>
          <motion.div variants={itemVariants}>
            <SocialsSection />
          </motion.div>
        </motion.div>
      </motion.div>
    </motion.main>
  );
};

export default Home;